<template>
  <add-edit-dialog>
    <crm-panel title="分配客户">
      <div class="page-buttons">
        <crm-button :text="'保存'" :disabled="saveDisabled" @click="customFormSubmit()">
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleGoBack()">
        </crm-button>
      </div>
      <el-form
        label-width="80px"
        ref="form"
        :model="form"
        :rules="formRule"
        class="distribute-form"
      >
        <el-form-item label="业务员：" prop="salesmanCode" :rules="formRule.salesmanCode">
          <el-select clearable filterable v-model="form.salesmanCode" value-key="code">
            <el-option
              v-for="item in clerkList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="客户："
          prop="distributeList"
          :rules="formRule.distributeList"
        >
          <crm-button :text="'选择客户'" @click="handleChooseCus"> </crm-button>
          <div class="table-wrap" v-if="form.distributeList.length">
            <el-table :data="form.distributeList" border style="width: 100%">
              <el-table-column prop="doctorName" label="客户名称" align="center">
              </el-table-column>
              <el-table-column prop="hospitalId" align="center" label="医院ID">
              </el-table-column>
              <el-table-column prop="hospitalName" align="center" label="医院">
              </el-table-column>
              <el-table-column prop="hospDeptName" align="center" label="科室">
              </el-table-column>
              <el-table-column width="120" align="center" label="地区">
                <template slot-scope="{ row }">
                  {{
                    [row.firstHospProvName, row.firstHospCityName]
                      .filter(Boolean)
                      .join("/")
                  }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <!-- v-if="webCustomerAuth.delete.auth" -->
                  <el-button @click="delCustom(scope.$index)" type="text" size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>

      <!-- 选择客户弹窗 -->
      <div v-if="chooseVisible">
        <el-dialog
          title="选择客户"
          width="70%"
          :visible.sync="chooseVisible"
          append-to-body
          @close="handleChooseClose"
        >
          <!-- 搜索条 -->
          <el-form :model="form" size="mini" label-width="20px" class="clearfix">
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入省、市查询"
                  v-model="chooseForm.regionName"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入医院ID查询"
                  v-model="chooseForm.hospitalId"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入医院名称查询"
                  v-model="chooseForm.hospitalName"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入科室名称查询"
                  v-model="chooseForm.hospDeptName"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入科室ID查询"
                  v-model="chooseForm.hospDeptId"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-input
                  class="search-input"
                  placeholder="请输入医生姓名查询"
                  v-model="chooseForm.doctorName"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="handleSearch"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <!-- 客户列表 -->
          <div class="table-wrap">
            <el-table
              :data="doctorList.results"
              border
              height="400px"
              v-loading="loading"
              :row-key="getRowKeys"
              @selection-change="saveSelection"
              style="width: 100%"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                prop="id"
                align="center"
                width="44"
              >
              </el-table-column>
              <el-table-column prop="doctorName" label="客户名称" align="center">
              </el-table-column>
              <el-table-column prop="hospitalId" align="center" label="医院ID">
              </el-table-column>
              <el-table-column prop="hospitalName" align="center" label="医院">
              </el-table-column>
              <el-table-column prop="hospDeptId" align="center" label="科室ID">
              </el-table-column>
              <el-table-column prop="hospDeptName" align="center" label="科室">
              </el-table-column>
              <el-table-column width="120" align="center" label="地区">
                <template slot-scope="{ row }">
                  {{
                    [row.firstHospProvName, row.firstHospCityName]
                      .filter(Boolean)
                      .join("/")
                  }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 客户列表分页 -->
          <div class="pageination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pagenation.pageNumber"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagenation.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="doctorList.totalCount"
            >
            </el-pagination>
          </div>
          <div slot="footer" class="dialog-footer">
            <crm-button
              :buttonType="'plain'"
              :text="'取消'"
              @click="handleChooseClose"
            ></crm-button>
            <crm-button :text="'确定'" @click="handleAddDoctors"></crm-button>
          </div>
        </el-dialog>
      </div>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import city from "@/scripts/city-diction";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
  },
  data() {
    return {
      loading: true,
      getRowKeys(row) {
        return row.id;
      },
      // 待提交的表单数据
      form: {
        distributeList: [],
        crmDoctor: [],
        salesmanCode: null,
        salesmanName: null,
      },
      // 表单校验规则
      formRule: {
        distributeList: [{ required: true, message: "请选择客户", trigger: "change" }],
        salesmanCode: [{ required: true, message: "请选择业务员", trigger: "change" }],
      },
      // 选择客户
      chooseVisible: false,
      // 选择客户-搜索
      chooseForm: {
        regionName: null,
        hospitalId: null,
        hospitalName: null,
        hospDeptId: null,
        hospDeptName: null,
        doctorName: null,
      },
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 100,
      },
      selectDoctors: [],
      saveDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "authority/userInfo",
      clerkList: "common/clerkList",
      doctorList: "customer/doctorList",
    }),
  },
  created() {
    // 业务员列表
    this.getClerkList({
      sourcePart:
        window.location.pathname === "/medicalCus/vaild" ? "medicalCus" : "customer",
    }).then(() => {
      this.form.salesmanCode = this.userInfo.userUid;
    });
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getClerkList: "common/getClerkList",
      getDoctorList: "customer/getDoctorList",
      saveDoctorDistribute: "customer/saveDoctorDistribute",
    }),
    handleChooseClose() {
      this.chooseVisible = false;
    },
    // 分配客户-移除客户
    delCustom(index) {
      this.form.distributeList.splice(index, 1);
    },
    handleGoBack() {
      this.$emit("close");
    },
    // 修改第一次失败后 后续提示一直存在的问题
    handleChooseCus() {
      this.chooseVisible = true;
      this.$refs.form.clearValidate("distributeList");
    },
    // 分配客户-确认
    customFormSubmit() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          if (this.form.distributeList.length > 500) {
            this.$message({
              type: "error",
              message: "一次最多选择500个客户！",
            });
            return;
          }
          this.saveDisabled = true;
          this.$notify.info({
            message: "保存中...",
            showClose: false,
            duration: 1000,
          });
          this.form.crmDoctor = [];
          this.form.distributeList.forEach((item) => {
            this.form.crmDoctor.push({
              pkid: item.pkid,
              id: item.id,
              doctorName: item.doctorName,
              firstHospProvName: item.firstHospProvName,
              firstHospCityName: item.firstHospCityName,
            });
          });
          this.form.salesmanName = this.clerkList.find(
            (item) => item.code === this.form.salesmanCode
          ).userName;
          const { distributeList, ...params } = this.form;
          this.saveDoctorDistribute({ ...params })
            .then(() => {
              this.$message({
                type: "success",
                message: "客户分配成功！",
              });
              this.$emit("save");
            })
            .finally(() => {
              this.saveDisabled = false;
              this.$notify.close();
            });
        }
      });
    },
    // 选择客户-搜索
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetDoctorList();
    },
    handleGetDoctorList() {
      this.loading = true;
      this.getDoctorList({
        ...this.chooseForm,
        ...this.pagenation,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 保存表格多选数据
    saveSelection(selection) {
      this.selectDoctors = selection;
    },
    // 选择客户-分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetDoctorList();
    },
    // 选择客户-分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetDoctorList();
    },
    handleAddDoctors() {
      if (this.selectDoctors.length) {
        this.handleChooseClose();
        this.form.distributeList.push(...this.selectDoctors);
        this.$message({
          type: "success",
          message: "客户选择成功！",
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择客户！",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";

.distribute-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding: 20px 50px;
}
</style>
